
import { Component, Prop } from "vue-property-decorator";
import { Task } from "@/store/modules";
import { mixins } from "vue-class-component";
import { CurrencyFormatMixin, DateFormatMixin, HeMixin } from "@/mixins";
import ServiceTypeBadge from "./detail/ServiceTypeBadge.vue";

@Component({
  components: { ServiceTypeBadge }
})
export class TaskCardInfo extends mixins(
  CurrencyFormatMixin,
  DateFormatMixin,
  HeMixin
) {
  @Prop({ default: () => null })
  private task!: Task | null;

  toTitleCase(str: string | null): string {
    if (!str) return '';
    return str.replace(/\w\S*/g, (txt) => 
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }
}

export default TaskCardInfo;
